import Promise$1 from 'bluebird';
import { Braintree } from './Braintree.js';
import { Payment } from '../../../models/Payment/Payment.js';
import { getPaymentMethodModel, PaymentMethod } from '../../../models/Payment/PaymentMethod.js';
import { PaymentNonce } from '../../../models/Payment/PaymentNonce.js';

class Billing {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.braintree = new Braintree(apiClient);
  }
  all() {
    return this.apiClient.get('v1/billing/paymentdata').then(response => response.data.map(paymentData => Payment.createFromResponse(paymentData)));
  }
  allDetails() {
    return this.all().then(data => Promise$1.all(data.map(payment => this.get(payment.id))));
  }
  get(paymentId) {
    return this.apiClient.get(`v1/billing/paymentdata/${paymentId}`).then(response => {
      const payment = response.data;
      return getPaymentMethodModel(PaymentMethod[payment.payment_method], payment);
    });
  }
  create(payment) {
    return this.apiClient.post('v1/billing/paymentdata', payment.getCreatePayload()).then(response => response.data);
  }
  registerPaymentMethod(payment) {
    return this.apiClient.post('v1/billing/payment-methods', payment.getCreatePayload()).then(response => response.data);
  }
  update(payment) {
    return this.apiClient.put(`v1/billing/paymentdata/${payment.id}`, payment.getCreatePayload()).then(response => response.data);
  }
  delete(payment) {
    return this.apiClient.delete(`v1/billing/paymentdata/${payment.id}`).then(response => response.data);
  }
  getNonce(payment) {
    return this.apiClient.get(`v1/billing/paymentdata/${payment.id}/nonce`).then(response => PaymentNonce.createFromResponse(response.data));
  }
  requestDirectDebit() {
    return this.apiClient.post('v1/billing/paymentdata/deferred/requests/direct_debit').then(response => response.data);
  }
}

export { Billing };
//# sourceMappingURL=Billing.js.map
